module.exports = __webpack_public_path__ + "img/sintesis.caa2130e.svg";